// P:\0PJ\synforge\frontend\styles\tokens.ts v2 2026.06.22

import api from "@/lib/api"

const FONT_MAP: Record<string, string> = {
  system:  "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  sans:    "'Inter', 'Helvetica Neue', Arial, sans-serif",
  mono:    "'JetBrains Mono', 'Fira Code', monospace",
  serif:   "'Georgia', 'Times New Roman', serif",
  rounded: "'Nunito', 'Varela Round', sans-serif",
}

export async function loadAndApplyTokens() {
  try {
    const res  = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/design-tokens/`)
    const data = await res.json()
    applyTokens(data)
  } catch (e) {
    console.warn("Failed to load design tokens, using defaults")
    applyTokens(null)
  }
}

export function applyTokens(t: any) {
  const root = document.documentElement

  const fontSize    = t?.font_size_base    ?? 13
  const fontFamily  = t?.font_family       ?? "system"
  const meetingSize = t?.meeting_font_size ?? "default"
  const theme       = t?.theme             ?? "dark"
  const rc          = t?.radius_card       ?? 16
  const rb          = t?.radius_button     ?? 8

  // CSS 변수 설정
  root.style.setProperty("--font-size-base",    `${fontSize}px`)
  root.style.setProperty("--font-size-meeting",
    meetingSize === "small" ? `${fontSize - 2}px` :
    meetingSize === "large" ? `${fontSize + 2}px` : `${fontSize}px`
  )
  root.style.setProperty("--font-family", FONT_MAP[fontFamily] || FONT_MAP.system)
  root.style.setProperty("--radius-card",   `${rc}px`)
  root.style.setProperty("--radius-button", `${rb}px`)
  root.style.setProperty("--radius-input",  `${t?.radius_input  ?? 8}px`)
  root.style.setProperty("--radius-badge",  `${t?.radius_badge  ?? 99}px`)
  root.style.setProperty("--spacing-card",  `${t?.spacing_card  ?? 20}px`)
  root.style.setProperty("--spacing-gap",   `${t?.spacing_gap   ?? 16}px`)

  // 테마
  root.setAttribute("data-theme", theme)

  // Tailwind 오버라이드 — head 마지막에 삽입해서 Tailwind 이후 적용 보장
  const styleId = "synforge-token-override"
  let styleEl   = document.getElementById(styleId) as HTMLStyleElement
  if (!styleEl) {
    styleEl    = document.createElement("style")
    styleEl.id = styleId
  }
  document.head.appendChild(styleEl)

  styleEl.textContent = `
    .rounded     { border-radius: ${Math.max(rb - 4, 2)}px !important; }
    .rounded-md  { border-radius: ${Math.max(rb - 2, 2)}px !important; }
    .rounded-lg  { border-radius: ${rb}px !important; }
    .rounded-xl  { border-radius: ${Math.round(rc * 0.75)}px !important; }
    .rounded-2xl { border-radius: ${rc}px !important; }
    .rounded-3xl { border-radius: ${rc + 4}px !important; }
    .rounded-full{ border-radius: 9999px !important; }

    body, p, span, div, button, input, textarea, select, a {
      font-size: ${fontSize}px !important;
    }
    .text-xs   { font-size: ${Math.max(fontSize - 2, 8)}px !important; }
    .text-sm   { font-size: ${Math.max(fontSize - 1, 9)}px !important; }
    .text-base { font-size: ${fontSize}px !important; }
    .text-lg   { font-size: ${fontSize + 2}px !important; }
    .text-xl   { font-size: ${fontSize + 4}px !important; }
    .text-2xl  { font-size: ${fontSize + 8}px !important; }
    .text-3xl  { font-size: ${fontSize + 12}px !important; }
  `
}